module.exports = {
  siteTitle: "Loaded Reports | We make understanding your business easy.", // Site title.
  siteTitleShort: "Loaded", // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: "Loaded Reports | We make understanding your business easy.", // Alternative site title for SEO.
  siteLogo: "/logos/loaded-logo.png", // Logo used for SEO and manifest.
  siteUrl: process.env.SITEURL, // Domain of your website without pathPrefix.
  siteDescription: "We make understanding your business easy.", // Website description used for RSS feeds/meta description tag.
  themeColor: "#5c8eff", // Used for setting manifest and progress theme colors.
  backgroundColor: "#2d2d2e", // Used for setting manifest background color.
}